import React from 'react';

import {
  StyledBoxMessageWeekly,
  StyledWrapperBox,
  StyledMessageTitle,
  DetailMessageTitle,
  StyledIconRazor
} from './style';

import { Razor } from '../../../../assets/images/index';

const NoMenuWeekly = () => (
  <StyledBoxMessageWeekly>
    <StyledWrapperBox>
      <StyledMessageTitle>
        El menú para esta semana no está disponible.
        <DetailMessageTitle> En breve lo publicaremos.</DetailMessageTitle>
      </StyledMessageTitle>
      <p>Disculpa las molestias.</p>
      <StyledIconRazor svg={Razor} />
    </StyledWrapperBox>
  </StyledBoxMessageWeekly>
);

export default NoMenuWeekly;
